// User-facing copy for the payment methods tab. No promises about timing or outcomes of retries.
// Proposed copy: the owner/designer approve the final text.

export const MSG_CARD_IN_USE =
  'This card is used by an active TicketLyfe membership subscription. Make another card your default first, then remove this one.'

export const MSG_RETRY_FAILED_CHECK =
  'We could not check outstanding payments right now. Your card was saved.'

export const deleteWarning = circles =>
  circles > 0
    ? `Removing this card leaves ${circles} of your Sou-Sou circle${circles === 1 ? '' : 's'} without a card for upcoming payments. You can add another card at any time.`
    : ''

// One line per retried payment (OutstandingRetry.results[]): charge status -> text
export const retryResultText = ({ circleName, status, failure }) => {
  switch (status) {
    case 'SUCCEEDED':
      return `${circleName}: the payment went through.`
    case 'FAILED':
      return `${circleName}: the payment did not go through${failure?.message ? ` (${failure.message})` : ''}.`
    case 'REQUIRES_ACTION':
      return `${circleName}: your bank needs an extra confirmation for this payment.`
    default:
      // CREATED, PROCESSING and any status we do not branch on
      return `${circleName}: the payment is being processed.`
  }
}
